import { Layout } from '@/components/Layout';
import { PageHeader } from '@/components/PageHeader';
import { Dashboard } from '@/components/Dashboard';
import { useEnhancedMobile } from '@/hooks/use-enhanced-mobile';

const HoldingsPage = () => {
  const { isMobile } = useEnhancedMobile();

  return (
    <Layout>
      <PageHeader 
        title="Holdings." 
        subtitle="Track and manage your investment portfolio"
      />
      <div className={`container mx-auto max-w-[1200px] ${isMobile ? 'px-2 py-2' : 'px-6 py-6'}`}>
        <Dashboard />
      </div>
    </Layout>
  );
};

export default HoldingsPage;
